export default __webpack_public_path__ + "static/media/Savage Leggings.d5165908.jpg";